import React from "react";
import { InfoItem, InputField } from "../../../utils/utils";
import { theme } from "../../../utils/theme";

const LocationCard = ({
    type = "printShop", // printShop | supplier | specialist
    isEditing,
    form,
    onEdit,
    onCancel,
    onSave,
    onChange,
}) => {
    const t = theme[type];

    return (
        <div className="bg-white rounded-[16px] border border-[#e4e5e7] overflow-hidden">
            {/* HEADER */}
            <div className="px-[20px] py-[14px] border-b border-[#f0f1f3]">
                <div className="flex items-center justify-between">
                    <p className="font-semibold text-[15px] text-[#212326]">
                        Location
                    </p>

                    {isEditing ? (
                        <div className="flex items-center gap-[8px]">
                            <button
                                onClick={onCancel}
                                className="px-[14px] py-[7px] rounded-[10px] font-semibold text-[13px]"
                                style={{
                                    backgroundColor: t.accentBg,
                                    color: t.primary,
                                }}
                            >
                                Cancel
                            </button>

                            <button
                                onClick={onSave}
                                className="px-[14px] py-[7px] rounded-[10px] font-semibold text-[13px] text-white"
                                style={{ backgroundColor: t.primary }}
                            >
                                Save
                            </button>
                        </div>
                    ) : (
                        <button
                            onClick={onEdit}
                            className="px-[14px] py-[7px] rounded-[10px] font-semibold text-[13px] text-white"
                            style={{ backgroundColor: t.primary }}
                        >
                            Edit
                        </button>
                    )}
                </div>
            </div>

            {/* BODY */}
            <div className="p-[20px]">
                {!isEditing ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-[16px]">
                        <InfoItem label="Address" value={form?.address?.street} />
                        <InfoItem label="City" value={form?.address?.city} />
                        <InfoItem label="Province" value={form?.address?.province} />
                        <InfoItem label="Postal Code" value={form?.address?.postalCode} />
                    </div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-[16px]">
                        <InputField
                            label="Address"
                            value={form?.address?.street}
                            onChange={(value) =>
                                onChange("street", value)
                            }
                        />

                        <InputField
                            label="City"
                            value={form?.address?.city}
                            onChange={(value) =>
                                onChange("city", value)
                            }
                        />

                        <InputField
                            label="Province"
                            value={form?.address?.province}
                            onChange={(value) =>
                                onChange("province", value)
                            }
                        />

                        <InputField
                            label="Postal Code"
                            value={form?.address?.postalCode}
                            onChange={(value) =>
                                onChange("postalCode", value)
                            }
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default LocationCard;